// extracted by mini-css-extract-plugin
export default {"DraggableCard":"bgc_a"};